/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';

export interface AppEvent {
  type: string;
  message?: string;
  value?: number;
  detail?: any;
}

export interface Logging {
  event(event: AppEvent): void;
  error(message: string, ...optionalParams: any[]): void;
  log(message: string): void;
}

// Logger context type
interface LoggingContextProps {
  log: (message: string, ...optionalParams: any[]) => void;
  error: (message: string, ...optionalParams: any[]) => void;
  event: (event: AppEvent) => void;
}

const defaultLoggingContext: LoggingContextProps = {
  log: () => {}, // No-op by default
  error: () => {}, // No-op by default
  event: () => {}, // No-op by default
};

// Logger Context
export const LoggingContext = createContext<LoggingContextProps>(defaultLoggingContext);

// Hook so we can use the LoggingContext
export const useLogging = () => useContext(LoggingContext);
